
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2026-08-01-investing-101-for-swe",
      function () {
        return require("private-next-pages/posts/2026-08-01-investing-101-for-swe.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2026-08-01-investing-101-for-swe"])
      });
    }
  